<template>
  <nav class="mb-4 my-md-5">
    <ul class="nav nav-once d-flex justify-content-between w-100">
      <li :class="['nav-item', pageNumber === 1 ? 'mr-auto' : pageNumber === 3 ? 'ml-auto' : 'mx-auto']" v-for="pageNumber in 3" :key="pageNumber">
        <button :class="['nav-link', { 'active': pageNumber === page }, { 'disabled': pageNumber > maxPage || pageNumber === page }]" :tabindex="pageNumber <= maxPage ? false : '-1'" :aria-disabled="pageNumber > maxPage || pageNumber === page" @click="pageNumber <= maxPage && pageNumber !== page ? goToPage(pageNumber) : false">
        <svg v-if="pageNumber === 3" xmlns="http://www.w3.org/2000/svg" width="15" height="17" aria-hidden="true" viewBox="0 0 448 512"><path fill="currentColor" d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>
        <span v-else>{{pageNumber}}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['page', 'maxPage'],
  methods: {
    goToPage(pageNumber) {
      this.$emit('proceed', pageNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-once {
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    height: 2px;
    background-color: white;
    right: 1rem;
    margin-top: -1px;
    z-index: -1;
  }

  .nav-link {
    width: 52px;
    height: 52px;
    line-height: 48px;
    background: var(--primary);
    color: white;
    border: 2px solid white;
    border-radius: 50%;
    text-align: center;
    padding: 0;

    &.active {
      background-color: white;
      color: var(--primary);
    }

    &:hover,
    &:focus {
      cursor: pointer;
      outline: none;
      box-shadow: 0 0 1rem rgba(255, 255, 255, 0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Account/LoginOnce/LoginOnceNav.vue